import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class ClaimDownloadArgs {
  @Field(t => Int)
  claimId!: number

  @Field(t => Int)
  downloadType!: number

  @Field(t => Int)
  fileType!: number

  @Field({ nullable: true })
  emailTo?: string
}
